<template>
  <div class="columns is-mobile is-centered">
    <div class="column">
      <button class="button is-info is-small" @click="logData()">Log Data to Console</button>
      <div class="tabs">
        <ul>
          <li :class="selectedLocation == 'all' ? 'is-active' : ''">
            <a href="#" @click="selectedLocation = 'all';">
              All
            </a>
          </li>

          <li v-for="location in locationList" :key="location" :class="selectedLocation == location ? 'is-active' : ''">
            <a href="#" @click="selectedLocation = location">
              {{ location }}
            </a>
          </li>
        </ul>
      </div>

      <div>
        <button @click="showCompletedRequests = !showCompletedRequests" class="button is-primary is-small is-pulled-right" v-html="showCompletedRequests ? 'Hide Completed Requests' : 'Show Completed Requests'"></button>
      </div>

      <table class="table is-striped is-hoverable is-fullwidth">
        <thead>
          <tr>
            <th>Issuer</th>
            <th>Description</th>
            <th>Reward</th>
            <th></th>
          </tr>
        </thead>

        <tbody>
          <template v-for="(request) in currentLocationRequests">
            <tr v-for="(task, key) in request.filteredTasks" :key="task.description">          
              <!-- <td v-html="request.location"/> -->
              <td v-if="key == 0" :rowspan="requestQuantityForIssuer(request.issuer)" v-html="request.issuer"/>
              <td v-html="task.description" :class="task.completed ? 'striked-text': ''" />
              <td v-html="task.reward" :class="task.completed ? 'striked-text': ''" />

              <td>
                <button v-if="!task.completed" @click="completeTask(task)" class="button is-primary is-small is-fullwidth">Complete</button>
                <button v-else @click="restoreTask(task)" class="button is-warning is-small is-fullwidth">Restore</button>
              </td>
            </tr>
          </template>
        </tbody>

      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'home',
  data() {
    return {
      selectedLocation: "",
      otherRequests: [],
      showCompletedRequests: false
    }
  },

  computed: {
    locationList() {
      return new Set(this.otherRequests.map(request => request.location));
    },

    currentLocationRequests() {
      let filtered;

      if (this.selectedLocation) {
        filtered = this.otherRequests.filter(request => request.location === this.selectedLocation);
        
        if (!filtered.length > 0) {
          filtered = this.otherRequests;
        }
      } else {
        filtered = this.otherRequests;
      }
      
      filtered.forEach(issuer => {
        issuer.filteredTasks = issuer.tasks.filter(task => !task.completed || this.showCompletedRequests);
      });

      return filtered;
    },

    currentLifeRanks() {
      return new Set(this.currentLife.challenges.map(challenge => challenge.rank));
    }
  },

  created() {
    this.$http.get('https://bitbucket.org/rafaoliveira/fantasy-life/raw/master/src/assets/other_requests.json')
      .then(res => this.otherRequests = res.body);
  },

  methods: {
    completeTask(task) {
      task.completed = true;
    },

    restoreTask(task) {
      task.completed = false;
    },

    filterChallengesByRank(rank) {
      return this.currentLifeOpenChallenges.filter(challenge => challenge.rank === rank);
    },

    logData() {
      console.log(JSON.stringify(this.currentLifeOpenChallenges));
    },

    requestQuantityForIssuer(issuer) {
      let issuerData = this.currentLocationRequests.find(request => request.issuer === issuer);
      if (issuerData) return issuerData.filteredTasks.length;
      else return 0;
    }
  }
}
</script>

<style scoped>
li {
  display: inline;
  list-style: none;
  padding: 3px;
}

.tabs ul {width:100%;flex-direction:row;flex-wrap:wrap;}
.tabs li {width:30%}

.striked-text {
  text-decoration: line-through;
}
</style>